__turbopack_context__.v({
  "buttons": "NotFound-module-scss-module__oDG7Cq__buttons",
  "copy": "NotFound-module-scss-module__oDG7Cq__copy",
  "headline": "NotFound-module-scss-module__oDG7Cq__headline",
  "imageCol": "NotFound-module-scss-module__oDG7Cq__imageCol",
  "inner": "NotFound-module-scss-module__oDG7Cq__inner",
  "minWidthImage": "NotFound-module-scss-module__oDG7Cq__minWidthImage",
  "textCol": "NotFound-module-scss-module__oDG7Cq__textCol",
  "wrapper": "NotFound-module-scss-module__oDG7Cq__wrapper",
});
